<button mat-icon-button [disabled]="zoningCode?.isDeleting || zoningCode?.isOrphan"
    [class.not-clickable-actions-buttons]="zoningCode?.isDeleting" class="actions-buttons">
    <mat-icon matTooltip="Improved reindex Zoning Code Process.
        Uses new indexing approach which guarantees more or less equal
        GAPI response time for each fetch data request. Recommended for big Zoning Codes."
        (click)="reindexZoningCode($event)" class="actions-mat-icons">
        keyboard_double_arrow_down</mat-icon>
</button>